<template>
  <svg
    class="cross"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 2541 2541"
    shape-rendering="geometricPrecision"
    text-rendering="geometricPrecision"
    image-rendering="optimizeQuality"
    fill-rule="evenodd"
    clip-rule="evenodd"
  >
    <path
      d="M29 172c-39-39-39-103 0-142s103-39 142 0l1099 1099L2369 30c39-39 103-39 142 0s39 103 0 142L1412 1271l1099 1099c39 39 39 103 0 142s-103 39-142 0L1270 1413 171 2512c-39 39-103 39-142 0s-39-103 0-142l1099-1099L29 172z"
      fill-rule="nonzero"
    />
  </svg>
</template>

<script>
export default {
  name: 'Cross',
};
</script>

<style scoped lang="scss">
.cross {
  display: block;
}
</style>
